import { Formation } from "../types"

import { CapNumberingEditor } from "./CapNumberingEditor"
import { PlayEditor } from "./PlayEditor"

export enum EditorContent {
  CAP_NUMBERING,
  PLAY_EDITING,
}

export const Editor: React.FC<{
  containerHeight: number
  containerWidth: number
  activeEditor?: EditorContent
  play: Formation
  selectedPlayer: number | null
  numbering?: (string | null)[] | undefined
  onSelectCapNumber: (cap: number | null) => () => void
  usedNumbers?: number[]
  isPlaying: boolean
  selectedFrame: number
  onSelectFrame: (number: number) => void
  onRemoveFrame: (position: number) => void
  onAddFrame: () => void
  onStartPlay: () => void
  onStopPlay: () => void
  onNextFrame: () => void
  onPrevFrame: () => void
  onSubmitPlay: ({
    saveAsNew,
    name,
  }: {
    saveAsNew: boolean
    name?: string
  }) => void
  playNameList: string[]
}> = ({
  containerHeight,
  containerWidth,
  activeEditor,
  play,
  selectedPlayer,
  numbering,
  onSelectCapNumber,
  usedNumbers,
  isPlaying,
  selectedFrame,
  onSelectFrame,
  onRemoveFrame,
  onAddFrame,
  onStartPlay,
  onStopPlay,
  onNextFrame,
  onPrevFrame,
  onSubmitPlay,
  playNameList = [],
}) => {

  if (activeEditor === EditorContent.CAP_NUMBERING) {
    return (
      <CapNumberingEditor
        numbering={numbering}
        selectedPlayer={selectedPlayer}
        onSelectCapNumber={onSelectCapNumber}
        usedNumbers={usedNumbers}
      />
    )
  }
  if (activeEditor === EditorContent.PLAY_EDITING) {
    return (
      <PlayEditor
        containerHeight={containerHeight}
        containerWidth={containerWidth}
        play={play}
        selectedFrame={selectedFrame}
        isPlaying={isPlaying}
        onSelectFrame={onSelectFrame}
        onRemoveFrame={onRemoveFrame}
        onAddFrame={onAddFrame}
        onStartPlay={onStartPlay}
        onStopPlay={onStopPlay}
        onNextFrame={onNextFrame}
        onPrevFrame={onPrevFrame}
        onSubmitPlay={onSubmitPlay}
        playNameList={playNameList}
      />
    )
  }
  return null
}
